<template>
  <div class="row">
    <div class="col-12">
      <b-card header="Pipeline" header-tag="h4" body-class="mb-3 record_card_body">
        <div v-if="!edit_pipeline" class="row">
          <div class="col-xl-3 col-md-6">
            <div class="pipeline">
              <span class="pipeline_type">COMPANY<br>TYPE</span>
              <span class="pipeline_status">{{ company.company_type }}</span>
              <span class="pipeline_update">{{ company.company_type_update | formatDate }}</span>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="pipeline">
              <span class="pipeline_type">lead<br>status</span>
              <span class="pipeline_status">{{ company.lead_status }}</span>
              <span class="pipeline_update">{{ company.lead_status_update | formatDate }}</span>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="pipeline">
              <span class="pipeline_type">pipeline<br>status</span>
              <span class="pipeline_status">{{ company.pipeline_status }}</span>
              <span class="pipeline_update">{{ company.pipeline_status_update | formatDate }}</span>
            </div>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="pipeline">
              <span class="pipeline_type">pipeline opportunity size</span>
              <span class="pipeline_status">{{ company.pipeline_opportunity_size }}</span>
              <span class="pipeline_update">{{ company.pipeline_opportunity_size_update | formatDate }}</span>
            </div>
          </div>
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <div class="col-8 text-center">
            <h3 class="mb-0" style="font-size: 1.15rem;"><span class="font-weight-bold">WEEKLY DEAL VALUE</span> &nbsp;&nbsp; {{ company.deal_value | currency }}</h3>
          </div>
          <div class="col-4">
            <button @click="edit_pipeline_show" class="btn orcaBtn blueBtn sm_btn float-right">Edit Pipeline</button>
          </div>
        </div>
        <div v-if="edit_pipeline" class="row">
          <div class="col-12">
            <ValidationObserver ref="updatePipelineForm" slim>
              <form role="form" @submit.prevent="update_pipeline_submit">
                <div class="row">
                  <!-- Primary Consultant -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="required" v-slot="{ errors, classes}" name="Primary Consultant" tag="div">
                      <label class="form-label" for="e_primary_consultant">Primary Consultant</label>
                      <multiselect v-model="e_pipeline.primary_consultant" id="e_primary_consultant" name="e_primary_consultant" placeholder=""
                                   label="name" :options="ms_opts.crm_users" :class="classes" :custom-label="e_primary_consultant_name" track-by="id"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Company Type -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{dirty, errors, classes}" name="Company Type" tag="div">
                      <label class="form-label" for="e_company_type">Company Type</label>
                      <multiselect v-model="e_pipeline.company_type" id="e_company_type" name="e_company_type" placeholder="" @select="onChangePipeLine(dirty,'e_company_type')"
                                   :options="ms_opts.company_type" :class="classes" label="value" track-by="id"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Lead Status -->
                  <!--                  <div class="col-xl-4 form-group">-->
                  <!--                    <ValidationProvider rules="" v-slot="{dirty, errors, classes}" name="Lead Status" tag="div">-->
                  <!--                      <label class="form-label" for="e_lead_status">Lead Status</label>-->
                  <!--                      <multiselect v-model="e_pipeline.lead_status" id="e_lead_status" name="e_lead_status" placeholder="" @select="onChangePipeLine(dirty,'e_lead_status')"-->
                  <!--                                   :options="ms_opts.lead_status" :class="classes" label="value" track-by="id"></multiselect>-->
                  <!--                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>-->
                  <!--                    </ValidationProvider>-->
                  <!--                  </div>-->
                  <!-- pipeline status -->
                  <div class="col-xl-4 form-group">
                    <ValidationProvider rules="" v-slot="{dirty, errors, classes}" name="Pipeline Status" tag="div">
                      <label class="form-label" for="e_pipeline_status">Pipeline Status</label>
                      <multiselect v-model="e_pipeline.pipeline_status" id="e_pipeline_status" name="e_pipeline_status" placeholder=""
                                   @select="onChangePipeLine(dirty,'e_pipeline_status')" :options="ms_opts.pipeline_status" :class="classes" label="value"
                                   track-by="id"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- pipeline Opportunity Size -->
                  <div class="col-xl-4 form-group">
                    <ValidationProvider rules="" v-slot="{dirty, errors, classes}" name="Pipeline Opportunity Size" tag="div">
                      <label class="form-label" for="e_pipeline_opportunity_size">Pipeline Opportunity Size</label>
                      <multiselect v-model="e_pipeline.pipeline_opportunity_size" id="e_pipeline_opportunity_size" name="e_pipeline_opportunity_size" placeholder=""
                                   @select="onChangePipeLine(dirty,'e_pipeline_opportunity_size')" :options="ms_opts.pipeline_opportunity" :class="classes"
                                   label="value" track-by="id"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- DEAL VALUE -->
                  <div class="col-xl-4 form-group">
                    <ValidationProvider rules="decimal" v-slot="{errors, classes}" name="Weekly Deal Value" tag="div">
                      <label class="form-label" for="e_deal_value">Weekly Deal Value</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <input type="text" v-model="e_pipeline.deal_value" id="e_deal_value" name="e_deal_value" class="form-input" :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
                <div class="row">
                  <div class="col-xl-6">
                    <button @click.prevent="cancel_edit_form('updatePipelineForm')" class="btn orcaBtn grey_bg">Cancel</button>
                  </div>
                  <div class="col-xl-6">
                    <button type="submit" class="btn orcaBtn">Update information</button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-xl-6">
      <b-card header="Office Contact Info" header-tag="h4" body-class="mb-3 record_card_body">
        <div v-if="!edit_office_info" class="row">
          <div class="col-md-6"><strong>Office Number:</strong></div>
          <div class="col-md-6" v-if="company.rel_profile.office_phone !== null">{{ company.rel_profile.office_phone.phone_number }}</div>
          <div class="col-md-6" v-else></div>
          <div class="col-md-6"><strong>Office Email:</strong></div>
          <div class="col-md-6" v-if="company.rel_profile.office_email !== null">{{ company.rel_profile.office_email.email_address }}</div>
          <div class="col-md-6" v-else></div>
          <div class="col-md-6"><strong>Office Website:</strong></div>
          <div class="col-md-6">{{ company.rel_profile.office_website }}</div>
          <div class="col-md-6"><strong>Office Opening Hours:</strong></div>
          <div class="col-md-6">
            <span v-if="company.rel_profile.open_time !== null">{{ company.rel_profile.open_time | formatHourMinTime }}</span>
            <span v-if="company.rel_profile.close_time !== null"> - {{ company.rel_profile.close_time | formatHourMinTime }}</span>
          </div>
          <div class="col-12">
            <hr>
          </div>
          <div class="col-12">
            <button @click="edit_office_info_show" class="btn orcaBtn blueBtn sm_btn float-right mt-1">Edit Office Contact Info</button>
          </div>
        </div>
        <div v-if="edit_office_info" class="row">
          <div class="col-12">
            <ValidationObserver ref="updateOfficeInfoForm" slim>
              <form role="form" @submit.prevent="update_office_info_submit">
                <div class="row">
                  <!-- Office Number -->
                  <ValidationProvider rules="" v-slot="{ errors, classes}" name="Office Number" tag="div" class="col-12 form-group"
                                      v-if="phones.length > 0 && !new_phone">
                    <label class="form-label" for="e_office_phone_ms">Office Number</label>
                    <multiselect v-model="e_office_info.office_phone" id="e_office_phone_ms" name="e_office_phone_ms" placeholder="" :options="ms_opts.phones"
                                 :class="classes" label="phone_number" track-by="id" @input="select_e_office_phone_number" :allow-empty="required"></multiselect>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <ValidationProvider rules="required|numeric|max:15" v-slot="{errors, classes}" name="Office Number" tag="div" class="col-12 form-group"
                                      v-else>
                    <label class="form-label" for="e_office_phone">Office Number</label>
                    <input type="text" v-model="e_office_info.office_phone" id="e_office_phone" name="e_office_phone" class="form-input" :class="classes" maxlength="15" required="true">
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <!-- Office Email -->
                  <ValidationProvider rules="required" v-slot="{ errors, classes}" name="Office Email" tag="div" class="col-12 form-group"
                                      v-if="emails.length > 0 && !new_email">
                    <label class="form-label" for="e_office_email_ms">Office Email</label>
                    <multiselect v-model="e_office_info.office_email" id="e_office_email_ms" name="e_office_email_ms" placeholder="" :options="ms_opts.emails"
                                 :class="classes" label="email_address" track-by="id" @input="select_e_office_email_address" :allow-empty="required"></multiselect>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <ValidationProvider rules="required|email" v-slot="{errors, classes}" name="Office Email" tag="div" class="col-12 form-group"
                                      v-else>
                    <label class="form-label" for="e_office_email">Office Email</label>
                    <input type="email" v-model="e_office_info.office_email" id="e_office_email" name="e_office_email" class="form-input" :class="classes" required="true">
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <!-- Office Website -->
                  <ValidationProvider rules="required" v-slot="{errors, classes}" name="Office Website" tag="div" class="col-12 form-group">
                    <label class="form-label" for="e_office_website">Office Website</label>
                    <input type="text" v-model="e_office_info.office_website" id="e_office_website" name="e_office_website" class="form-input" :class="classes" required="true">
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <!-- Office Open Time -->
                  <ValidationProvider rules="" v-slot="{errors, classes}" name="Open Time" tag="div" class="col-xl-6 form-group">
                    <label class="form-label" for="open_time">Open Time</label>
                    <multiselect v-model="e_office_info.open_time" id="open_time" :class="classes" name="open_time" placeholder="" :options="ms_opts.open_time" :allow-empty="required"></multiselect>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <!-- Office End Time -->
                  <ValidationProvider rules="" v-slot="{errors, classes}" name="Close Time" tag="div" class="col-xl-6 form-group">
                    <label class="form-label" for="close_time">Close Time</label>
                    <multiselect v-model="e_office_info.close_time" id="close_time" :class="classes" name="close_time" placeholder=""
                                 :options="ms_opts.close_time" required="true" :allow-empty="required"></multiselect>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>

                <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
                <div class="row">
                  <div class="col-xl-6">
                    <button @click.prevent="cancel_edit_form('updateOfficeInfoForm')" class="btn orcaBtn grey_bg">Cancel</button>
                  </div>
                  <div class="col-xl-6">
                    <button type="submit" class="btn orcaBtn">Update information</button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-xl-6">
      <b-card header="Genius Services" header-tag="h4" body-class="mb-3 record_card_body">
        <div v-if="!edit_genius_services" class="row">
          <div class="col-12">
            <h5 class="font-weight-bold mb-2 bp_color">Services the client has opted into</h5>
          </div>
          <div class="col-xl-6">
            <strong class="d-block">Payroll Service</strong>
            <span v-if="services.service_payroll">Yes</span>
            <span v-if="!services.service_payroll">No</span>
          </div>
          <div class="col-xl-6">
            <strong class="d-block">Recruitment Service</strong>
            <span v-if="services.service_recruitment">Yes</span>
            <span v-if="!services.service_recruitment">No</span>
          </div>
          <div class="col-xl-6">
            <strong class="d-block">Resourcing Service</strong>
            <span v-if="services.service_resourcing">Yes</span>
            <span v-if="!services.service_resourcing">No</span>
          </div>
          <div class="col-xl-6">
            <strong class="d-block">Legal Service</strong>
            <span v-if="services.service_legal">Yes</span>
            <span v-if="!services.service_legal">No</span>
          </div>
          <div class="col-12">
            <hr>
          </div>

          <div class="col-12">
            <button @click="edit_genius_services_show" class="btn orcaBtn blueBtn sm_btn float-right">Edit Genius Services</button>
          </div>
        </div>
        <div v-if="edit_genius_services" class="row">
          <div class="col-12">
            <ValidationObserver ref="updateGeniusServicesForm" slim>
              <form role="form" @submit.prevent="update_genius_services_submit">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <label class="col-xl-8 cardLabel" for="e_service_payroll">Payroll Services</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="e_genius_services.service_payroll" id="e_service_payroll" name="e_service_payroll" :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- Recruitment Services -->
                  <div class="col-12">
                    <div class="row">
                      <label class="col-xl-8 cardLabel" for="e_service_recruitment">Recruitment Services</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="e_genius_services.service_recruitment" id="e_service_recruitment" name="e_service_recruitment"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- Resourcing Service -->
                  <div class="col-12">
                    <div class="row">
                      <label class="col-xl-8 cardLabel" for="e_service_resourcing">Resourcing Services</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="e_genius_services.service_resourcing" id="e_service_resourcing" name="e_service_resourcing"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- Legal Services -->
                  <div class="col-12">
                    <div class="row">
                      <label class="col-xl-8 cardLabel" for="e_service_legal">Legal Services</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="e_genius_services.service_legal" id="e_service_legal" name="e_service_legal" :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
                <div class="row">
                  <div class="col-xl-6">
                    <button @click.prevent="cancel_edit_form('updateGeniusServicesForm')" class="btn orcaBtn grey_bg">Cancel</button>
                  </div>
                  <div class="col-xl-6">
                    <button type="submit" class="btn orcaBtn">Update information</button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-12">
      <b-card header="NOTES" header-tag="h4" body-class="mb-3 record_card_body">
        <datatable :type="'notes'" :recordType="'company'" :rowData="notes" :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"
                   :heightStyle="heightStyle"></datatable>
      </b-card>
    </div>
  </div>

</template>

<script>
import Datatable from "datatables/datatable";
import Multiselect from "vue-multiselect";
import BootstrapToggle from 'vue-bootstrap-toggle';

// JS Arrays
import hours_of_day from 'resources/js/assets/crm_options/shift_times';

export default {
  name: "Dashboard",
  components: {
    Multiselect,
    BootstrapToggle,
    Datatable
  },
  props: ['company', 'notes', 'phones', 'emails', 'services'],
  data() {
    return {
        required: true,
      // NOTES
      heightStyle: 'height: 400px !important',
      loadingMessage: 'Loading Notes...',
      noRowsMessage: 'No Notes Left on Company or Contacts',
      columns: [
        { headerName: 'Date', valueGetter: this.noteDate, maxWidth: 150 },
        { headerName: 'Type', field: 'note_type', maxWidth: 150 },
        { headerName: 'Left By', field: 'logged_by_name', maxWidth: 150 },
        { headerName: 'Note', field: 'note_description', minWidth: 200 },
        { headerName: 'Note On', valueGetter: this.noteSubject, maxWidth: 200 },
      ],
      // Multiselect Options
      ms_opts: {
        crm_users: [],
        company_type: this.$store.state.crm_options.company_type,
        lead_status: ['No Answer', 'Call back cold', 'Call back warm', 'Call back hot', 'Qualified', 'Visit booked',
          'Visit held', 'Client Contract sent', 'Client contract signed', 'Client Registration', 'Client', 'Deal Lost'],
        pipeline_status: this.$store.state.crm_options.company_pipeline_status,
        pipeline_opportunity: this.$store.state.crm_options.company_pipeline_opportunity_size,
        v3_partnership_terms: this.$store.state.crm_options.payment_term,
        v3_partnership_margin_type: this.$store.state.crm_options.fee_type,
        open_time: hours_of_day,
        close_time: hours_of_day,

        phones: this.phones,
        emails: this.emails,
      },

      // pipeline
      edit_pipeline: false,
      e_pipeline: {
        company_id: this.company.id,
        primary_consultant: this.company.primary_consultant,
        primary_consultant_id: null,
        company_type: {id: this.company.company_type_id, value: this.company.company_type},
        company_type_id: null,
        lead_status: this.company.lead_status,
        pipeline_status: {id: this.company.pipeline_status_id, value: this.company.pipeline_status},
        pipeline_status_id: null,
        pipeline_opportunity_size: {id: this.company.pipeline_opportunity_size_id, value: this.company.pipeline_opportunity_size},
        pipeline_opportunity_size_id: null,
        deal_value: '',

        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      },
      // office info
      edit_office_info: false,
      new_phone: false,
      new_email: false,
      e_office_info: {},
      // // Genius Services
      edit_genius_services: false,
      e_genius_services: {},
    }
  },
  computed: {
    // check_pre_agreement() {
    //  if (this.notEmptyObject(this.pre_agreement) && this.notEmptyObject(this.accounts_info)) {
    //   return (this.check_pre_agreement_null_values() && this.check_pre_agreement_payroll_fees_to_contractors() && this.check_pre_agreement_gm_charge_agreed()
    //    && this.check_pre_agreement_gm_payment_terms() && this.check_pre_agreement_v3_partnership());
    //  }
    //  else {
    //   return false
    //  }
    // },
    // are_there_contracts() {
    //  return this.notEmptyObject(this.contracts);
    // },
    // check_signed_contracts() {
    //  let check = false;
    //  if (this.notEmptyObject(this.contracts)) {
    //   for (let i = 0; i < this.contracts.length; i++) {
    //    if (this.contracts[i].is_signed) {
    //     check = true;
    //    }
    //   }
    //  }
    //  return check;
    // },
  },
  beforeMount() {
    this.e_office_info = Object.assign({}, this.company.rel_profile);
    this.e_genius_services = Object.assign({}, this.services);
  },
  mounted() {
    axios.get(this.crmApiPath + 'user/index').then(users => this.ms_opts.crm_users = users.data);
    // Office Contact Info
    if (this.phones.length > 0) {
      if (this.ms_opts.phones.filter(p => p.phone_number === 'ADD NEW NUMBER').length === 0) {
        this.ms_opts.phones.push({id: 0, phone_number: 'ADD NEW NUMBER'})
      }
    }
    else {
      this.new_phone = true;
    }
    if (this.emails.length > 0) {
      if (this.ms_opts.emails.filter(p => p.email_address === 'ADD NEW EMAIL ADDRESS').length === 0) {
        this.ms_opts.emails.push({id: 0, email_address: 'ADD NEW EMAIL ADDRESS'})
      }
    }
    else {
      this.new_email = true;
    }
  },
  methods: {
    /**
     * NOTES
     * ------------------------------------------------------------------------------------------------------------------------------------
     */
    noteDate(params) {
      return this.$options.filters.formatDateTime(params.data.note_updated_at || params.data.note_date);
    },

    noteSubject(params) {
      // if note is against a contact
      if (params.data.contact_id && params.data.contact_name) {
        return `Contact (${params.data.contact_name})`;
      }

      // worker note?
      if (params.data.worker_id && params.data.worker_name) {
        return `Worker (${params.data.worker_name})`;
      }

      return 'Company';
    },

    // date_time_value_getter(params) {
    //   return this.$options.filters.formatDateTime(params.data.updated_at);
    // },
    // note_left_on_value_getter(params) {
    //   if (params.data.contact_id !== null && params.data.belongs_to !== null) {
    //     return params.data.belongs_to.person.first_name + ' ' + params.data.belongs_to.person.surname
    //   }
    //   else {
    //     return 'Company'
    //   }
    // },
    // note_left_by_value_getter(params) {
    //   if (params.data.note_log_by) {
    //     return params.data.note_log_by.first_name + ' ' + params.data.note_log_by.surname
    //   }
    //   else {
    //     return '';
    //   }
    // },

    //
    // check_pre_agreement_null_values() {
    //  // TODO -- && this.accounts_info.pay_period_day !== null
    //  return this.company.utr_number !== null && this.company.utr_status !== null
    //   && this.accounts_info.pay_cycle !== null
    //   && this.accounts_info.pay_week_end_day !== null
    //   && this.accounts_info.pay_instruction_day !== null
    //   && this.accounts_info.pay_client_payment_day !== null
    //   && this.accounts_info.pay_worker_payment_day !== null
    //   && this.accounts_info.pay_worker_payment_time !== null
    //   && this.accounts_info.pay_worker_text_day !== null
    //   && this.accounts_info.gm_solution !== null
    //   && this.pre_agreement.vat_perc_worked_to !== null;
    // },
    // check_pre_agreement_payroll_fees_to_contractors() {
    //  if (this.pre_agreement.payroll_fees_to_contractors === false) {
    //   return true
    //  }
    //  else {
    //   return this.pre_agreement.payroll_fees_to_contractors_amount !== null;
    //  }
    // },
    // check_pre_agreement_gm_charge_agreed() {
    //  if (this.pre_agreement.gm_charge_agreed) {
    //   return this.accounts_info.fee_type !== null && this.accounts_info.admin_fee !== null;
    //  }
    //  else {
    //   return false
    //  }
    // },
    // check_pre_agreement_gm_payment_terms() {
    //  if (this.accounts_info.payment_terms === false) {
    //   return true
    //  }
    //  else {
    //   return this.accounts_info.payment_terms_length !== null && this.accounts_info.payment_terms_perc !== null;
    //  }
    // },
    // check_pre_agreement_v3_partnership() {
    //  if (this.pre_agreement.v3_partnership === false) {
    //   return true
    //  }
    //  else {
    //   return this.pre_agreement.v3_partnership_terms !== null && this.pre_agreement.v3_partnership_margin_type !== null && this.pre_agreement.v3_partnership_margin_value !== null;
    //  }
    // },
    //
    onChangePipeLine(dirty, input) {
      if (input === 'e_company_type') {
        this.e_pipeline.company_type_update = this.$moment.utc().format('YYYY-MM-DD');
      }
      if (input === 'e_lead_status') {
        this.e_pipeline.lead_status_update = this.$moment.utc().format('YYYY-MM-DD');
      }
      if (input === 'e_pipeline_status') {
        this.e_pipeline.pipeline_status_update = this.$moment.utc().format('YYYY-MM-DD');
      }
      if (input === 'e_pipeline_opportunity_size') {
        this.e_pipeline.pipeline_opportunity_size_update = this.$moment.utc().format('YYYY-MM-DD');
      }
    },
    //
    cancel_edit_form(form) {
      if (form === 'updatePipelineForm') {
        this.edit_pipeline = false;
      }
      if (form === 'updateOfficeInfoForm') {
        this.e_office_info = {};
        this.edit_office_info = false;
      }
      if (form === 'updateGeniusServicesForm') {
        this.e_genius_services = {};
        this.edit_genius_services = false;
      }
    },
    // PIPELINE
    e_primary_consultant_name({first_name, surname}) {
      return `${first_name} ${surname}`;
    },
    edit_pipeline_show() {
      this.edit_pipeline = true;
      //  if (!this.check_pre_agreement || !this.are_there_contracts || !this.check_signed_contracts) {
      //   for (let i = 0; i < this.ms_opts.company_type.length; i++) {
      //    if (this.ms_opts.company_type[i] === 'Active') {
      //     this.ms_opts.company_type.splice(i, 1);
      //     i--;
      //    }
      //   }
      //  }
    },
    update_pipeline_submit() {
      this.$refs.updatePipelineForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.updatePipelineForm);
        }
        else {
          this.e_pipeline.primary_consultant_id = this.e_pipeline.primary_consultant.id;
          this.e_pipeline.company_type_id = this.e_pipeline.company_type.id;
          this.e_pipeline.company_type_updated = this.$moment.utc().format('YYYY-MM-DD HH:mm:ss');
          this.e_pipeline.pipeline_status_id = this.e_pipeline.pipeline_status.id;
          this.e_pipeline.pipeline_status_updated = this.$moment.utc().format('YYYY-MM-DD HH:mm:ss');
          this.e_pipeline.pipeline_opportunity_size_id = this.e_pipeline.pipeline_opportunity_size.id;
          this.e_pipeline.pipeline_opportunity_size_updated = this.$moment.utc().format('YYYY-MM-DD HH:mm:ss');

          this.$store.commit('SET_UPDATE_COMPANY_ID', this.company.id);

          axios.patch(this.crmApiPath + 'company/' + this.company.id, this.e_pipeline).then(() => {
            this.$bus.$emit('logs::reload', {action: true});
            this.$bus.$emit('company::reload', {action: true});
            this.edit_pipeline = false;
            this.$nextTick(() => this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'}));
          });
        }
      });
    },
    /**
     * Office information
     * ------------------------------------------------------------------------------------------------------------------------------------
     */
    edit_office_info_show() {
      this.e_office_info = Object.assign({}, this.company.rel_profile);
      this.$nextTick(() => this.edit_office_info = true)
    },
    update_office_phone_email() {
      return new Promise(phone_email => {
        let phone_email_save_promises = [];
        phone_email_save_promises.push(new Promise(resolve => {
          // Add new phone number (STORE)
          if (this.new_phone && this.e_office_info.office_phone !== "" && this.e_office_info.office_phone !== null) {
            let phone = {
              company_id: this.company.id,
              belongs_to_id: this.company.id,
              belongs_to_type: 'App\\Models\\Companies\\Company',
              contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
              log_by_id: this.$store.state.auth.me.id,
              phone_type_id: 50, // Office Landline
              phone_number: this.e_office_info.office_phone,
              record_type: 'company'
            };
            axios.post(this.crmApiPath + 'contact_info/phone', phone).then(phone_id => {
              this.e_office_info.office_phone_id = phone_id.data;
              resolve();
            });
          }
          else {
            if (this.e_office_info.office_phone !== null && this.notEmptyObject(this.e_office_info.office_phone)) {
              this.e_office_info.office_phone_id = this.e_office_info.office_phone.id;
            }
            resolve();
          }
        }));
        phone_email_save_promises.push(new Promise(resolve => {
          if (this.new_email && this.e_office_info.office_email !== "" && this.e_office_info.office_email !== null) {
            let email = {
              company_id: this.company.id,
              belongs_to_id: this.company.id,
              belongs_to_type: 'App\\Models\\Companies\\Company',
              contact_info_model_type: 'App\\Models\\Contact_Info\\Email',
              log_by_id: this.$store.state.auth.me.id,
              email_type_id: 60, // office email
              email_address: this.e_office_info.office_email,
              record_type: 'company'
            };
            axios.post(this.crmApiPath + 'contact_info/email', email).then(email_id => {
              this.e_office_info.office_email_id = email_id.data;
              resolve();
            });
          }
          else {
            if (this.e_office_info.office_email !== null && this.notEmptyObject(this.e_office_info.office_email)) {
              this.e_office_info.office_email_id = this.e_office_info.office_email.id;
            }
            resolve();
          }
        }));
        Promise.all(phone_email_save_promises).then(() => phone_email());
      });
    },
    select_e_office_phone_number(number) {
      if (number !== null) {
        if (number.phone_number === 'ADD NEW NUMBER') {
          this.new_phone = true;
          this.e_office_info.office_phone = ''
        }
        else {
          this.e_office_info.office_phone_id = number.id
        }
      }
    },
    select_e_office_email_address(email) {
      if (email !== null) {
        if (email.email_address === 'ADD NEW EMAIL ADDRESS') {
          this.new_email = true;
          this.e_office_info.office_email = ''
        }
        else {
          this.e_office_info.office_email_id = email.id
        }
      }
    },
    update_office_info_submit() {
      this.$refs.updateOfficeInfoForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.updateOfficeInfoForm);
        }
        else {
          this.$store.commit('SET_UPDATE_COMPANY_ID', this.company.id);
          this.update_office_phone_email().then(() => {
            this.e_office_info.log_by_type = 'App\\Models\\Users\\User';
            this.e_office_info.log_by_id = this.$store.state.auth.me.id;
            axios.patch(this.crmApiPath + 'company/profile/' + this.e_office_info.id, this.e_office_info).then(() => {
              this.$bus.$emit('logs::reload', {action: true});
              this.$bus.$emit('company::reload', {action: true});
              this.edit_office_info = false;
              this.$nextTick(() => this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'}))
            });
          })
        }
      });
    },
    /**
     * Services
     * ------------------------------------------------------------------------------------------------------------------------------------
     */
    edit_genius_services_show() {
      this.e_genius_services = Object.assign({}, this.services);
      this.$nextTick(() => this.edit_genius_services = true)
    },
    update_genius_services_submit() {
      this.$refs.updateGeniusServicesForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.updateGeniusServicesForm);
        }
        else {
          this.e_genius_services.log_by_type = 'App\\Models\\Users\\User';
          this.e_genius_services.log_by_id = this.$store.state.auth.me.id;
          if (!this.notEmptyObject(this.services)) {
            axios.post(this.crmApiPath + 'company/services', this.e_genius_services).then(() => {
              this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
              this.$bus.$emit('logs::reload', {action: true});
              this.$bus.$emit('company::reload', {action: true});
              this.edit_office_info = false;
            })
          }
          else {
            axios.patch(this.crmApiPath + 'company/services/' + this.e_genius_services.id, this.e_genius_services).then(() => {
              this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
              this.$bus.$emit('logs::reload', {action: true});
              this.$bus.$emit('company::reload', {action: true});
              this.edit_office_info = false;
            })
          }
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
.sm_btn {
  display:     inline-block;
  width:       auto;
  padding:     0 15px;
  line-height: 30px;
  font-size:   0.65rem;
}

.pipeline {
  margin-bottom: 10px;

  .pipeline_type, .pipeline_status, .pipeline_update {
    display:    block;
    text-align: center;
  }

  .pipeline_type {
    font-size:      0.9rem;
    text-transform: uppercase;
    font-weight:    bold;
    color:          $bc_3;
    line-height:    15px;
  }

  .pipeline_status {
    font-size:      1.35rem;
    text-transform: uppercase;
    font-weight:    bold;
    color:          $bc_1;
    line-height:    35px;
  }

  .pipeline_update {
    font-size:      0.9rem;
    text-transform: uppercase;
    font-weight:    bold;
    color:          $bc_2;
  }
}
</style>
